import axios from 'axios';
import createSignedRequest from './createSignedRequest';
import { toggleAlertMessage } from '../action';
const { apiURL } = require('./apiURL');

// types of action
const Types = {
  LIST: 'HELP_LIST',
  TOGGLE: 'HELP_TOGGLE',
};

const showHelp = (status) => ({
  type: Types.TOGGLE,
  status,
});

const updateHelp = (response) => ({
  type: Types.LIST,
  payload: response,
});

const fetchHelp = () => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const response = await axios(
        await createSignedRequest('GET', apiURL + `/my/help`, null, { Organisation: String(state.currentOrganisation) })
      );

      console.log('fetchHelp', response);
      dispatch(updateHelp(response.data));
    } catch (e) {
      console.log('fetchHelp Error', e);
    }
  };
};

const filenameFromContentDisposition = (header) => {
  if (typeof header !== 'string') return null;
  const utf8Match = /filename\*=UTF-8''([^;\n]+)/i.exec(header);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].replace(/["']/g, '').trim());
    } catch (e) {
      return null;
    }
  }
  const asciiMatch = /filename=["']?([^"'\n;]+)["']?/i.exec(header);
  return asciiMatch ? asciiMatch[1].trim() : null;
};

const errorFromBlob = async (blob) => {
  if (!(blob instanceof Blob)) return null;
  try {
    const parsed = JSON.parse(await blob.text());
    return parsed?.error || parsed?.message || null;
  } catch (e) {
    return null;
  }
};

/**
 * Downloads the Activity Data Helper workbook generated by `GET /my/data-helper.xlsx`.
 *
 * @param {string} [locale='en_GB'] Locale used for the workbook content.
 * @returns {Function} Thunk resolving to `true` when the file was saved, `false` otherwise.
 */
const downloadDataHelper = (locale = 'en_GB') => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      const request = await createSignedRequest('GET', `${apiURL}/my/data-helper.xlsx?locale=${locale}`, null, {
        Organisation: String(state.currentOrganisation),
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const response = await axios({
        ...request,
        responseType: 'blob',
      });

      const blob = response.data;
      if (blob?.type?.includes('application/json')) {
        throw new Error((await errorFromBlob(blob)) || 'Download failed');
      }

      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = filenameFromContentDisposition(response.headers?.['content-disposition']) || 'CYF-Data-Helper.xlsx';
      anchor.rel = 'noopener';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(url);

      return true;
    } catch (e) {
      console.log('downloadDataHelper Error', e);
      const message = (await errorFromBlob(e?.response?.data)) || 'Could not download the Data Helper Tool, please try again.';
      dispatch(toggleAlertMessage(true, message, 'error', 5000));
      return false;
    }
  };
};

const Actions = {
  fetchHelp,
  showHelp,
  downloadDataHelper,
};

export { Actions, Types };
